import React, { useEffect, useState } from "react";
import ProfileForm from "../components/ProfileForm";
import { profileAPI } from "../utils/API";
import { UserProfile } from "../types/profile";
import ProfileUpdateForm from "../components/ProfileUpdateForm";
import { LoaderPrimary } from "../../common/components/Loader/Loader";
import useAuthUserId from "auth/hooks/useAuthUser";

const ProfilePage = () => {
  const userId = useAuthUserId();
  const [data, setData] = useState<UserProfile | null>(null);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { getProfileByUser } = profileAPI;

  // API call-----------------------------------
  useEffect(() => {
    if(userId){
      setData({userId: userId} as any);
      handleFetchEvent(userId);
    }
  }, [userId]);

  const handleFetchEvent = async (slug: string) => {
    try {
      setIsLoading(true);
      const response = await getProfileByUser(slug);
      setData(response.userprofile);
      setIsLoading(false);
    } catch (error: any) {
      setErrorMessage(error);
      setIsLoading(false);
    }
  };

  const handleUpdate = async (profileData: UserProfile, slug: string) =>{
    return profileAPI.UpdateUserProfile(profileData, slug ?? "");
  }

  const handleCreate = async (profileData: UserProfile): Promise<any> =>{
    return profileAPI.CreateUserProfile(profileData);
  }

  // API call-----------------------------------

  return (
    <div className=''>
      {isLoading && <LoaderPrimary />}
      {!isLoading && data?._id && <ProfileUpdateForm userData={data} onUpdate={handleUpdate} />}
      {!isLoading && !data?._id && 
        <ProfileUpdateForm 
          userData={{userId: userId} as UserProfile} 
          onCreate={handleCreate} 
          onUpdate={handleUpdate}
          />
      }
    </div>
  );
};

export default ProfilePage;
